import { createQueryKeys } from "@lukemorales/query-key-factory"

export default createQueryKeys("masterclasses", {
  masterclassesList: params => ({
    queryKey: ["masterclassesList", params],
  }),
  upcomingMasterclass: () => ({
    queryKey: ["upcomingMasterclass"],
  }),
  getMasterClassDetails: slug => ({
    queryKey: ["getMasterClassDetails", slug],
  }),
})
